export default __webpack_public_path__ + "static/media/23_ITRI.5e883d0d.png";